export default __webpack_public_path__ + "static/media/nft_image_3.495cf96a.png";